import React from 'react';
import { useLanguage } from '@languages/index';

interface GuidelineCheckModalProps {
  onConfirm: () => void;
}

const GuidelineCheckModal: React.FC<GuidelineCheckModalProps> = ({
  onConfirm,
}) => {
  const language = useLanguage();
  const languageTexts = { ...language.common } as any;

  return (
    <div className="flex flex-col items-start bg-white rounded-lg p-12 w-[600px]">
      <h2 className="text-[22px] font-bold mb-[26px]">
        {languageTexts.guideline_final_check_title}
      </h2>

      <p className="text-[15px] text-start mb-[35px]">
        {languageTexts.guideline_final_check_description}
      </p>

      <button
        onClick={onConfirm}
        className="w-full bg-black text-white py-4 rounded text-[16px] font-medium hover:bg-gray-800 transition-colors"
      >
        {languageTexts.guideline_confirm_button}
      </button>
    </div>
  );
};

export default GuidelineCheckModal;
